const mapList = {
  9601: ['//z.shop.jd.com/#/home'],
  9602: ['//z.shop.jd.com/restful/app/index#/marketMain'],
  9603: ['//z.shop.jd.com/restful/app/index#/activityMain'],
  9606: ['/myBusiness/index.action'],
  9604: ['//z.shop.jd.com/restful/app/index#/activityMain'],
  9605: ['/system/help.action'],
  81121: ['//z.shop.jd.com/restful/app/awards#/rightsList'],
  81122: ['//z.shop.jd.com/restful/app/awards#/unionActivityList']
}
export default mapList



// WEBPACK FOOTER //
// ./src/router/routerMap.js